<script>
    import { onMount } from "svelte";
    import l from "./utils/locale";

    let collapseEl;
    export let name;
    export let open = false;
    onMount(() => {
        onClickCaption();
    });
    function onClickCaption(e) {
        const next = collapseEl.nextElementSibling;
        if (next && next.classList.contains("collapsable")) {
            next.classList.toggle("activeCollapse");
            open = next.classList.contains("activeCollapse");
        }
    }
</script>

<div
    bind:this={collapseEl}
    on:click={onClickCaption}
    class="figcaption noselect"
    style={`background-color: ${
        open ? "var(--main-color)" : "var(--inactive-color)"
    }`}
>
    {l[name]}
</div>

<style>
    :global(.activeCollapse) {
        display: block !important;
    }
    :global(.collapsable) {
        display: none;
    }
    :global(.displayBlock) {
        display: block;
    }
    .figcaption {
        position: relative;
        cursor: pointer;
        box-shadow: 0 1px 1px var(--darkgray-color) inset;
        width: 100%;
        padding: 5px 0;
        background-color: var(--inactive-color);
        color: white;
        text-align: center;
    }
</style>
